/* ------------ For login api ------------------- */
export const REACT_APP_BASE_URL = "https://gateway.5paisa.com/";
export const REACT_APP_TRADEAPIHUB_BASE_URL = "https://tradeapihub.5paisa.com/";
export const REACT_APP_API_HEADER_KEY = "U2FsdGVkX18+tJ6+vKLm1jvtvidGe3tJ5e/9+dYEe7LJrxfwvYtcj3llFIXbtcE6s3bJMsppnRZZcOFKoM5pwA==";
export const REACT_APP_TRADE_API_GATEWAY_KEY = "U2FsdGVkX1/RNumBRbkAgMXkkhS7ii+zWX7CYQvo4bMtwC26NgswYx4AbYbI5JbSDg6XYMAljb/Odn7AGPCPRA==";
export const APPNAME = "5PTRADE";
export const APPVER = "1.0";
export const APP_SOURCE = "09";
export const SESSIONTRANFERKEY = "4dddd59bdab77bace6189d001f96487e";
export const REACT_MARKET_DEPTH_KEY = "U2FsdGVkX1+RxocJq0yq6FWC6z7tRn/OiaM7pUNxKutSwrhJPzqndmwtn11mIXaWoeylv03caoKa5/TQSlgASvPZn8zoCroL6pIq77Pn2K4=";
export const CLIENTCID_Depth = "U2FsdGVkX1+pfKUdmf2azNpFneqKpmrgsglTMdGuA5U=";
export const OSNAME = "Web"; //"Android";
export const REQUESTCODE = "5PSTWV";
export const PREFERENCE_BASE_URL = "https://tradeapihub.5paisa.com/pwaprod_route/chart/preference/";
export const METHOD_FOR_CHART_SOCKET = "subscribe";
export const OPT_FOR_CHART_SOCKET = "marketfeed";
export const UNSUBS_METHOD_FOR_CHART_SOCKET = "unsubscribe";
export const THEME_COOKIE = "theme";
export const CRYPTO_KEY = "842a357c4b385726090aa184b75b691075da95e6ddd4eb40";
export const SOCKET_SUBSCRIPTION_METHODS = {
    MARKET_FEED_V3: "MarketFeedV3",
    DEPTH_20_SERVICE: "20depth",
    BASE_GREEKS: "optiongreek",
    DEPTH_SERVICE: "MarketDepthService",
    SCRIPT_INFO_FOR_FUTURE: "openinterest",
    NEW_BASE_GREEKS: "optiongreek",
    GREEKS_INSTRUMENT: "OG",
};
export const SOCKET_EVENT = {
    CONNECT_SOCKET: "CONNECT_SOCKET",
    DISCONNECT_SOCKET: "DISCONNECT_SOCKET",
    SOCKET_STATUS: "SOCKET_STATUS",
    SUBSCRIBE: "SUBSCRIBE",
    UNSUBSCRIBE: "UNSUBSCRIBE",
    UNSUBSCRIBE_BY_SUBSCRIBER: "UNSUBSCRIBE_BY_SUBSCRIBER",
    UNSUBSCRIBE_ALL: "UNSUBSCRIBE_ALL",
    RESUBSCRIBE: "RESUBSCRIBE",
    RECONNECT_TO_SOCKET: "RECONNECT_TO_SOCKET",
    SOCKET_ERROR: "SOCKET_ERROR",
    IS_WINDOW_FOCUSED: "IS_WINDOW_FOCUSED",
    SOCKET_DATA: "SOCKET_DATA",
    MARKETFEED_DATA: SOCKET_SUBSCRIPTION_METHODS.MARKET_FEED_V3,
    DEPTH_DATA: SOCKET_SUBSCRIPTION_METHODS.DEPTH_SERVICE,
    DEPTH_20_DATA: SOCKET_SUBSCRIPTION_METHODS.DEPTH_20_SERVICE,
    OPEN_INTEREST_DATA: SOCKET_SUBSCRIPTION_METHODS.SCRIPT_INFO_FOR_FUTURE,
    GREEKS_DATA: SOCKET_SUBSCRIPTION_METHODS.BASE_GREEKS,
    ORDER_DATA: "ORDER_DATA",
    LOGGLY_DATA: "LOGGLY_DATA",
    ANALYTICS_API_FAILURE: "ANALYTICS_API_FAILURE",
    CALL_POSITION_DATA: "CALL_POSITION_DATA",
};
export const niftyScripInfoData = {
    "CacheTime": 21600,
    "Message": "Success",
    "Status": 0,
    "Data": {
        "ScripCode": 999920000,
        "Exch": "N",
        "ExchType": "C",
        "Name": "NIFTY",
        "FullName": "NIFTY",
        "ShortName": "NIFTY",
        "Series": "EQ",
        "Expiry": "01 Jan 1980",
        "StrikeRate": 0.00,
        "CPType": "EQ",
        "InstrumentType": "INDICE",
        "IsIndice": "Y"
    }
};
export const niftySymbolName = "NSE:NIFTY";
export const niftyTicker = "NSE:NIFTY/999920000-C";
export const niftyMarketsession_time = "0915-1530:23456";
export const niftyMarket_holiday_correction = "1815-1915:20231112;0915-1530:20240120;0915-1000,1130-1230:20240302;0915-1000,1130-1230:20240518;1800-1900:20241101;0915-1530:20250201";
export const niftyMarket_holiday_session = "20240122,20240126,20240308,20240325,20240329,20240411,20240501";
/* -------------- end of login api ----------------- */
